import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { mmsColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getMms } from "../../../../api/sim";

const COPY_KEYS = ["id", "msisdn", "enable", "status", "created_at", "last_updated"];

const TmobilejMmsBatch = () => (
  <BatchDetail
    title="MMS"
    apiGet={__getMms}
    client={CLIENTS.tmobilej}
    columnsFactory={mmsColumns}
    copyKeys={COPY_KEYS}
    retryOperation="mms_update"
    showTerminate
    getRowPath={(row) => `/tmobilej/mms/${row.id}`}
  />
);

export default TmobilejMmsBatch;
